export type QuestionType = 'single' | 'multiple' | 'judge';

export interface QuestionOption {
  label: string;
  content: string;
}

export interface Question {
  id: string;
  type: QuestionType;
  content: string;
  options: QuestionOption[];
  answer: string[];
  groupId?: string;
  explanation?: string;
}

export interface QuestionGroup {
  id: string;
  name: string;
  order: number;
  questionIds: string[];
}

export interface HQBMetadata {
  title: string;
  description?: string;
  author?: string;
  createdAt: string;
  updatedAt: string;
  totalQuestions: number;
  tags?: string[];
}

export interface HQBFile {
  hqbVersion: string;
  metadata: HQBMetadata;
  groups: QuestionGroup[];
  questions: Question[];
}

export interface QuizBank {
  id: string;
  name: string;
  source: 'builtin' | 'user';
  addedAt: string;
  hqb: HQBFile;
}

export interface QuizSession {
  bankId: string;
  mode?: 'default' | 'exam' | 'homework' | 'halfExam';
  questions: Question[];
  currentIndex: number;
  answers: Record<string, string[]>;
  wrongAttempts: Record<string, number>;
  isFinished: boolean;
  startTime: string;
  elapsedTime: number;
}

export interface QuizConfig {
  selections: Array<{ bankId: string; groupIds?: string[] }>;
  count: number;
  mode?: 'default' | 'exam' | 'homework' | 'halfExam';
  shuffleQuestions?: boolean;
  shuffleOptions?: boolean;
}

export interface AppSettings {
  defaultQuickCount: number;
  shuffleQuestions: boolean;
  shuffleOptions: boolean;
  autoNext: boolean;
  autoNextDelay: number;
  selectedBankIds: string[];
  showExplanation: boolean;
  homeworkMode: boolean;
  halfExamMode: boolean;
  examMode: boolean;
  randomBank: boolean;
  showNavOnQuiz: boolean;
}

export const DEFAULT_SETTINGS: AppSettings = {
  defaultQuickCount: 20,
  shuffleQuestions: true,
  shuffleOptions: true,
  autoNext: true,
  autoNextDelay: 800,
  selectedBankIds: [],
  showExplanation: true,
  homeworkMode: false,
  halfExamMode: false,
  examMode: false,
  randomBank: true,
  showNavOnQuiz: false,
};

export const QUESTION_TYPE_LABELS: Record<QuestionType, string> = {
  single: '单选题',
  multiple: '多选题',
  judge: '判断题',
};

export interface UploadedFile {
  file: File;
  name: string;
  size: number;
  lastModified: number;
}

export const UPLOAD_ALLOWED_EXTENSIONS = ['.hqb'];
export const MAX_FILE_SIZE = 10 * 1024 * 1024;
